import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { FormModel } from "src/app/models/api/form.model";
import { Config } from "src/app/config";

@Injectable()
export class CommandCreateForm extends CommandAction {

    /**
     * 
     * @param parent Parent of the node to be created
     * @param cloneFrom Node to clone from
     * @returns 
     */
    public execute(parent?: WidgetsAbstract, cloneFrom?: WidgetsAbstract): WidgetsFormModel {
        const form = new WidgetsFormModel();
        form.createdBy = Config.user.iNumber;
        form.created = (new Date()).toISOString();

        form.isEdit = true;
        form.isSelected = true;   // A new Form starts selected

        // TODO: For now copy as well to data before removing it from WidgetsFormModel
        const formModel = new FormModel();
        formModel.createdBy = form.createdBy;
        formModel.created = form.created;
        form.data = formModel;

        return form;              
    }
}
